import React from 'react'
import { Box, makeStyles, createStyles, Typography } from '@material-ui/core'

const LegalBasis = () => {
  // eslint-disable-next-line no-unused-vars
  const classes = useStyles()
  return (
    <Box>
      <Typography variant="h6">Legal basis of processing</Typography>
      <Box component="ul">
        <Typography component="li" variant="body1">
          Users have given their consent for one or more specific purposes.
          Note: Under some legislations the Owner may be allowed to process
          Personal Data until the User objects to such processing (“opt-out”),
          without having to rely on consent or any other of the following legal
          bases. This, however, does not apply, whenever the processing of
          Personal Data is subject to European data protection law;
        </Typography>
        <Typography component="li" variant="body1">
          provision of Data is necessary for the performance of an agreement
          with the User and/or for any pre-contractual obligations thereof;
        </Typography>
        <Typography component="li" variant="body1">
          processing is necessary for compliance with a legal obligation to
          which the Owner is subject;
        </Typography>
      </Box>
      <Typography variant="body1">
        In any case, the Owner will gladly help to clarify the specific legal
        basis that applies to the processing, and in particular whether the
        provision of Personal Data is a statutory or contractual requirement, or
        a requirement necessary to enter into a contract.
      </Typography>
    </Box>
  )
}

const useStyles = makeStyles((theme) => createStyles({}))

export default LegalBasis
